import { configureStore } from '@reduxjs/toolkit';
import { type TCreateStoreFunctionSignature } from '../../common/redux';
import { createOfferCalculatorApi } from '../api';
import { offerCalculatorSlice } from './slices/offerCalculatorSlice';

export const createOfferCalculatorStore = ((context, preloadedState, devTools) => {
  const offerCalculatorApi = createOfferCalculatorApi(context);

  return configureStore({
    reducer: {
      [offerCalculatorApi.reducerPath]: offerCalculatorApi.reducer,
      [offerCalculatorSlice.name]: offerCalculatorSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ thunk: { extraArgument: context } }).concat(offerCalculatorApi.middleware),
    preloadedState,
    devTools,
  });
}) satisfies TCreateStoreFunctionSignature;
